/* INTENTION native cart drawer v1.1
   One cart owner: Pipeline's Shopify Ajax cart. Rebuy is intentionally absent. */
(function () {
  'use strict';
  if (window.__intNativeCartBooted) return;
  window.__intNativeCartBooted = true;

  var DRAWER = '#drawer-cart';
  var pendingTimer = 0;
  var pendingStartedAt = 0;
  var pendingBaselineCount = null;
  var pendingVerifyTimer = 0;
  var pendingVerifyAttempts = 0;
  var mutationObserver = null;
  var drawerStateObserver = null;
  var quizHydrateQueued = false;
  /* 2026-10-26 (checkout-bounce): the drawer opens on the tap, before the add lands, so it
     first shows the bag as it was. The Adding note now stays, and the old lines and subtotal
     stay dimmed, until the drawer markup matches the new cart (every line key and quantity)
     and the subtotal has been replaced. Capped at 5 s so it can never hang. */
  var pendingSubtotalHTML = null;
  var settleTimer = 0;
  var settleCount = -1;

  function drawer() {
    return document.querySelector(DRAWER);
  }

  function isOpen() {
    var el = drawer();
    return !!(el && el.classList.contains('drawer--visible'));
  }

  function parseCount(value) {
    var count = parseInt(value, 10);
    return isNaN(count) ? null : count;
  }

  function currentCartCount() {
    var el = drawer();
    var count = el ? parseCount(el.getAttribute('data-int-cart-count')) : null;
    if (count !== null) return count;
    var headerCount = document.querySelector('[data-header-cart-count]');
    return headerCount ? parseCount(headerCount.getAttribute('data-header-cart-count')) : null;
  }

  /* 2026-10-03 speed. Pipeline already refreshes the drawer after its own add
     (theme:cart:change, then api-cart-items and api-cart-subtotal). A blanket
     theme:cart:reload on top of that made every add fetch cart.js four times and
     the sections three times, measured in Chrome 2026-10-03. Reload is now asked
     for ONLY when the drawer's markup disagrees with the cart it was told about:
     the empty state still showing, or fewer item rows than cart lines. */
  function drawerDisagrees(cart) {
    var el = drawer();
    if (!el || !cart) return false;
    var empty = el.querySelector('[data-cart-empty]');
    var emptyShown = empty && !empty.classList.contains('cart--hidden');
    var rows = el.querySelectorAll('[data-cart-item]').length;
    if (cart.item_count > 0 && emptyShown) return true;
    if (cart.items && rows < cart.items.length) return true;
    if (cart.item_count === 0 && rows > 0) return true;
    return false;
  }
  function reloadIfStale(cart, delay) {
    setTimeout(function () {
      if (drawerDisagrees(cart)) {
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }
    }, typeof delay === 'number' ? delay : 160);
  }

  function clearPendingVerifier(resetAttempts) {
    if (pendingVerifyTimer) {
      clearTimeout(pendingVerifyTimer);
      pendingVerifyTimer = 0;
    }
    if (resetAttempts !== false) pendingVerifyAttempts = 0;
  }

  function verifyPendingCart(delay) {
    clearPendingVerifier(false);
    if (!pendingStartedAt) return;
    pendingVerifyTimer = setTimeout(function checkCart() {
      pendingVerifyTimer = 0;
      if (!pendingStartedAt) return;
      pendingVerifyAttempts += 1;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      root = root.replace(/\/?$/, '/');
      window.fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart verification failed');
          return response.json();
        })
        .then(function (cart) {
          if (!pendingStartedAt) return;
          if (pendingBaselineCount === null || cart.item_count > pendingBaselineCount) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true
            }));
            reloadIfStale(cart, 200);
            return;
          }
          if (pendingVerifyAttempts < 4) {
            verifyPendingCart(700);
          } else {
            setPending(false);
          }
        })
        .catch(function () {
          if (!pendingStartedAt) return;
          if (pendingVerifyAttempts < 4) verifyPendingCart(700);
          else setPending(false);
        });
    }, typeof delay === 'number' ? delay : 1200);
  }

  function setPending(on) {
    var el = drawer();
    if (!el) return;
    var note = el.querySelector('[data-int-cart-pending]');
    if (!note) return;

    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = 0;
    }

    if (on) {
      if (!pendingStartedAt) {
        pendingStartedAt = Date.now();
        pendingBaselineCount = currentCartCount();
        pendingVerifyAttempts = 0;
      }
      if (pendingSubtotalHTML === null) {
        var sub0 = el.querySelector('[data-cart-subtotal]');
        pendingSubtotalHTML = sub0 ? sub0.textContent.replace(/\s+/g, '') : '';
      }
      note.hidden = false;
      el.classList.add('int-cart-is-pending');
      pendingTimer = setTimeout(function () {
        setPending(false);
      }, 9000);
      verifyPendingCart(1200);
    } else {
      note.hidden = true;
      el.classList.remove('int-cart-is-pending');
      pendingStartedAt = 0;
      pendingBaselineCount = null;
      pendingSubtotalHTML = null;
      if (settleTimer) { clearTimeout(settleTimer); settleTimer = 0; }
      settleCount = -1;
      clearPendingVerifier();
    }
  }

  function linesMatch(cart) {
    var el = drawer();
    if (!el || !cart || !cart.items) return false;
    var box = el.querySelector('[data-line-items]') || el;
    if (box.querySelectorAll('[data-cart-item]').length !== cart.items.length) return false;
    var qty = {};
    var inputs = box.querySelectorAll('[data-update-cart]');
    for (var i = 0; i < inputs.length; i++) qty[inputs[i].getAttribute('data-update-cart')] = parseInt(inputs[i].value, 10);
    for (var j = 0; j < cart.items.length; j++) {
      if (qty[cart.items[j].key] !== cart.items[j].quantity) return false;
    }
    return true;
  }

  function settleWhenRendered(cart) {
    if (!pendingStartedAt || !cart) return;
    if (settleTimer && settleCount === cart.item_count) return;
    if (settleTimer) clearTimeout(settleTimer);
    settleCount = cart.item_count;
    clearPendingVerifier();
    var started = Date.now();
    (function check() {
      settleTimer = 0;
      if (!pendingStartedAt) return;
      var el = drawer();
      var sub = el && el.querySelector('[data-cart-subtotal]');
      var subFresh = !sub || pendingSubtotalHTML === null || sub.textContent.replace(/\s+/g, '') !== pendingSubtotalHTML;
      if ((linesMatch(cart) && subFresh) || Date.now() - started > 5000) {
        setPending(false);
        return;
      }
      settleTimer = setTimeout(check, 100);
    })();
  }

  function syncDrawerState(open) {
    var el = drawer();
    if (!el) return;
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('int-native-cart-open', open);
    document.documentElement.classList.toggle('int-native-cart-open', open);
    var buttons = document.querySelectorAll('[data-drawer-toggle="drawer-cart"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (!open) setPending(false);
  }

  function openCart(options) {
    options = options || {};
    var el = drawer();
    if (!el) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      window.location.href = root + 'cart';
      return false;
    }

    if (options.pending) setPending(true);
    if (!isOpen()) {
      el.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
    syncDrawerState(true);
    hydrateQuizWords();
    setTimeout(queueCue, 60); setTimeout(queueCue, 600); setTimeout(queueCue, 1500);
    return true;
  }

  function closeCart() {
    var el = drawer();
    if (!el) return;
    el.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
    syncDrawerState(false);
  }

  window.__intOpenCartDrawer = openCart;
  window.__intCloseCartDrawer = closeCart;
  window.__intSetCartPending = setPending;

  function isAddButton(target) {
    if (!target || !target.closest) return false;
    var button = target.closest('button, input[type="submit"], [role="button"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return false;
    if (button.matches('[data-decrease-quantity], [data-increase-quantity]')) return false;
    return true;
  }

  /* Capture runs before the product form's target listener. The drawer therefore
     starts moving on the same tap, while Pipeline keeps owning the actual add. */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (typeof event.button === 'number' && event.button !== 0) return;
    if (!isAddButton(event.target)) return;
    openCart({ pending: true });
  }, true);

  /* Keyboard submits and custom forms that submit without a click. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    openCart({ pending: true });
  }, true);

  /* Any legacy add flow that still asks for Pipeline's product popdown is
     converted into the drawer. This prevents a second cart UI from flashing. */
  document.addEventListener('theme:cart:popdown', function (event) {
    event.stopImmediatePropagation();
    openCart({ pending: false });
    var popCart = event && event.detail ? event.detail.cart : null;
    if (popCart) reloadIfStale(popCart, 80);
    else setTimeout(function () {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }, 80);
  }, true);

  function updateHeaderCount(cart) {
    var el = drawer();
    if (!el || !cart) return;
    el.setAttribute('data-int-cart-count', String(cart.item_count || 0));
    var count = el.querySelector('[data-int-cart-header-count]');
    if (count) count.textContent = cart.item_count > 0 ? '· ' + cart.item_count : '';
  }

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    updateHeaderCount(cart);

    /* Opening before the add request can make Pipeline report the old cart first.
       Only finish the optimistic state once item_count has actually increased. */
    if (pendingStartedAt && cart && (pendingBaselineCount === null || cart.item_count > pendingBaselineCount)) {
      settleWhenRendered(cart);
      /* Pipeline can announce the new count before it has replaced the empty
         drawer markup. Check once it has had a moment, and refresh only if the
         markup still disagrees with the cart. */
      reloadIfStale(cart, 220);
    }

    queueQuizHydration();
    setTimeout(queueQuizHydration, 180);
  });

  function savedQuizWords() {
    try {
      var words = JSON.parse(localStorage.getItem('int_quiz_words') || '[]');
      if (!Array.isArray(words)) return [];
      return words.map(function (word) { return String(word || '').trim(); }).filter(Boolean).slice(0, 3);
    } catch (error) {
      return [];
    }
  }

  function setTextIfChanged(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function hydrateQuizWords() {
    var words = savedQuizWords();
    var modules = document.querySelectorAll(DRAWER + ' [data-int-cart-quiz]');
    /* ONE Word since 2026-10-06 (Nils): the quiz result is words[0]; the other entries the quiz
       still stores are data only and never shown. */
    var hero = words[0] || '';
    var signature = hero;

    for (var i = 0; i < modules.length; i++) {
      var module = modules[i];
      if (!hero) {
        if (!module.hidden) module.hidden = true;
        module.removeAttribute('data-int-cart-quiz-signature');
        continue;
      }

      /* The line-items observer also sees text-node replacements. Writing the
         same text on every observer pass creates an endless microtask loop in
         Chromium. Only touch the DOM when the quiz result actually changed. */
      if (module.getAttribute('data-int-cart-quiz-signature') === signature && !module.hidden) continue;

      setTextIfChanged(module.querySelector('[data-int-cart-hero]'), hero);
      module.hidden = false;
      module.setAttribute('data-int-cart-quiz-signature', signature);
    }
  }

  function queueQuizHydration() {
    if (quizHydrateQueued) return;
    quizHydrateQueued = true;
    setTimeout(function () {
      quizHydrateQueued = false;
      hydrateQuizWords();
    }, 0);
  }

  window.addEventListener('storage', function (event) {
    if (event.key === 'int_quiz_words') queueQuizHydration();
  });

  /* 2026-10-03: the Ajax shipping quote (postcode form, /cart/prepare_shipping_rates.json)
     was removed. Every market has fixed rates, so snippets/int-cart-delivery.liquid prints
     the shipping per parcel server side and Pipeline's section reload keeps it current. */

  function bindDrawerLifecycle() {
    var el = drawer();
    if (!el || el.__intLifecycleBound) return;
    el.__intLifecycleBound = true;
    el.addEventListener('theme:drawer:open', function () {
      syncDrawerState(true);
      setTimeout(queueQuizHydration, 0);
    });
    el.addEventListener('theme:drawer:close', function () {
      setTimeout(function () { syncDrawerState(false); }, 0);
    });

    if (window.MutationObserver) {
      if (drawerStateObserver) drawerStateObserver.disconnect();
      var lastOpenState = isOpen();
      drawerStateObserver = new MutationObserver(function () {
        var nextOpenState = isOpen();
        if (nextOpenState === lastOpenState) return;
        lastOpenState = nextOpenState;
        syncDrawerState(nextOpenState);
      });
      drawerStateObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    }

    var items = el.querySelector('[data-line-items]');
    if (items && window.MutationObserver) {
      if (mutationObserver) mutationObserver.disconnect();
      mutationObserver = new MutationObserver(function () {
        queueQuizHydration();
      });
      mutationObserver.observe(items, { childList: true, subtree: true });
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-int-cart-discount-form]')) return;
    event.preventDefault();
    var input = form.querySelector('[data-int-cart-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) {
      if (input) input.focus();
      return;
    }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    root = root.replace(/\/?$/, '/');
    var redirect = window.location.pathname + window.location.search + window.location.hash;
    try { sessionStorage.setItem('int_reopen_cart_after_discount', '1'); } catch (storageError) {}
    window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect));
  });

  function shouldReopenAfterDiscount() {
    try {
      if (sessionStorage.getItem('int_reopen_cart_after_discount') !== '1') return false;
      sessionStorage.removeItem('int_reopen_cart_after_discount');
      return true;
    } catch (storageError) {
      return false;
    }
  }

  /* 2026-10-07 (Nils): a down arrow at the bottom of the bag's scrolling list while there is more below it.
     The chevron is the homepage hero's scroll icon (snippets/icon-core-chevron-down.liquid). The cue is the last
     child of the scroll box and sticky, so it rides the bottom edge and hides itself at the end of the list. */
  var CUE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>';
  var cueFrame = 0;
  function cueLabel() {
    var l = (document.documentElement.lang || 'en').slice(0, 2);
    return l === 'da' ? 'Rul ned' : (l === 'de' ? 'Nach unten scrollen' : 'Scroll down');
  }
  function cueBox() {
    var el = drawer();
    return el ? el.querySelector('[data-drawer-scrolls]') : null;
  }
  function updateCue() {
    cueFrame = 0;
    var box = cueBox();
    if (!box) return;
    var cue = box.querySelector('.int-cart-scrollcue');
    if (!cue) {
      cue = document.createElement('div');
      cue.className = 'int-cart-scrollcue';
      cue.innerHTML = '<button type="button" class="int-cart-scrollcue__btn" aria-label="' + cueLabel() + '">' + CUE_SVG + '</button>';
      cue.firstChild.addEventListener('click', function () {
        var b = cueBox();
        if (b) b.scrollBy({ top: Math.round(b.clientHeight * 0.7), behavior: 'smooth' });
      });
    }
    if (cue.parentNode !== box || cue !== box.lastElementChild) box.appendChild(cue);
    if (!box.__intCueBound) {
      box.__intCueBound = true;
      box.addEventListener('scroll', queueCue, { passive: true });
      if (window.MutationObserver) new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) { if (list[i].target !== cue && !cue.contains(list[i].target)) { queueCue(); return; } }
      }).observe(box, { childList: true, subtree: true });
    }
    var more = isOpen() && box.scrollHeight - box.clientHeight - box.scrollTop > 24;
    box.classList.toggle('int-cart-has-more', more);
  }
  function queueCue() {
    if (cueFrame) return;
    cueFrame = (window.requestAnimationFrame || setTimeout)(updateCue);
  }
  window.addEventListener('resize', queueCue);
  document.addEventListener('theme:drawer:open', function () { setTimeout(queueCue, 60); setTimeout(queueCue, 600); setTimeout(queueCue, 1500); }, true);

  /* 2026-10-26 checkout-bounce (Nils): the shop uses the drawer only. The /cart page (reached from the
     bag icon in checkout) sends the shopper back to the last page they were on, with the drawer open.
     That last page is remembered here, on every page except /cart and checkout. */
  function rememberPage() {
    try {
      if (/\/cart\/?$/.test(location.pathname) || /\/checkouts?\//.test(location.pathname)) return;
      sessionStorage.setItem('int_last_page', location.pathname + location.search);
    } catch (e) {}
  }

  function boot() {
    rememberPage();
    bindDrawerLifecycle();
    queueQuizHydration();
    syncDrawerState(isOpen());
    queueCue();
    if (shouldReopenAfterDiscount()) {
      /* 2026-10-26: retry until the theme's drawer has wired its open listener (it may boot after us). */
      (function tryOpen(n) {
        setTimeout(function () {
          if (isOpen()) return;
          openCart({ pending: false });
          if (n < 12) setTimeout(function () { if (!isOpen()) tryOpen(n + 1); }, 250);
        }, n ? 0 : 60);
      })(0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Shopify's theme editor can replace the overlay section without reloading the
     page. Rebind to the new drawer node so preview/testing behaves like storefront. */
  document.addEventListener('shopify:section:load', function (event) {
    var container = event && event.target;
    if (!container || !container.querySelector || !container.querySelector(DRAWER)) return;
    setTimeout(boot, 0);
  });
})();
